import { t } from 'i18next';
import { ICrumb } from '@ui-modules/types';
import {
  BookingDetailsPage,
  BookingListPage,
  ChecklistDetailsPage,
  CostRecoveryReportPage,
  CountryReportPage,
  CreateAgencyInvoicePage,
  CreateIndividualInvoicePage,
  DriversListPage,
  EntryPage,
  FeedbacksPage,
  FinancialsMenuPage,
  IndividualInvoiceListPage,
  InvoiceHistoryPage,
  MobilityMenuPage,
  MobilityPlannerPage,
  MobilityPlannerNewPage,
  ReportingAreaMenuPage,
  ResourcesPage,
  ServiceCostSettingsPage,
  VehiclesChecklistPage,
  VehiclesListPage,
  LogbookPage,
  LogbookPageDetails,
} from '@pages';

import backgroundImage from '@assets/img/default/background.jpg';
import bgChecklist from '@assets/img/default/bg_checklist_report_page.jpeg';

export default [
  {
    path: '/',
    Component: EntryPage,
    backgroundImage,
    isBackgroundImage: true,
  },
  {
    path: '/bookings',
    Component: BookingListPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('crumbs.bookingsList'),
  },
  {
    path: '/bookings/:id',
    Component: BookingDetailsPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('crumbs.bookingDetails'),
  },
  {
    path: '/bookings/accept/:id',
    Component: MobilityPlannerPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.mobilityPlanner'),
  },
  {
    path: '/bookings/:id/edit-booking/:driveId',
    Component: MobilityPlannerPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.mobilityPlanner'),
  },
  {
    path: '/bookings/:id/edit-drive/:driveId',
    Component: MobilityPlannerPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.mobilityPlanner'),
  },
  {
    path: '/feedbacks',
    Component: FeedbacksPage,
    isNavigation: true,
    name: t('common.customerSatisfaction'),
  },
  {
    path: '/financials',
    Component: FinancialsMenuPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.financials'),
  },
  {
    path: '/financials/cost-recovery-report',
    Component: CostRecoveryReportPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.costRecoveryReport'),
  },
  {
    path: '/financials/cost-recovery-report/invoice/:id',
    Component: CreateAgencyInvoicePage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('crumbs.createAgencyInvoice'),
  },
  {
    path: '/financials/create-invoice-list',
    Component: IndividualInvoiceListPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('crumbs.bookings'),
  },
  {
    path: '/financials/create-invoice-list/:id',
    Component: CreateIndividualInvoicePage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('invoice.createInvoice'),
  },
  {
    path: '/financials/service-cost-setting',
    Component: ServiceCostSettingsPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.serviceCostSettings'),
  },
  {
    path: '/financials/history-invoice-list',
    Component: InvoiceHistoryPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('invoice.createInvoice'),
  },
  {
    path: '/mobility-management',
    Component: MobilityMenuPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.myMobility'),
  },
  {
    path: '/new-mobility-planner',
    Component: MobilityPlannerNewPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.mobilityPlanner'),
  },
  // TODO: remove old planner page
  {
    path: '/mobility-planner',
    Component: MobilityPlannerPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.mobilityPlanner'),
  },
  {
    path: '/mobility-management/vehicles-checklist',
    Component: VehiclesChecklistPage,
    backgroundImage: bgChecklist,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('mobility.vehiclesChecklist'),
  },
  {
    path: '/mobility-management/vehicles-checklist/:id',
    Component: ChecklistDetailsPage,
    backgroundImage: bgChecklist,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('mobility.vehiclesChecklist'),
  },
  {
    path: '/mobility-management/driver-list',
    Component: DriversListPage,
    isNavigation: true,
    name: t('mobility.myDrivers'),
  },
  {
    path: '/mobility-management/vehicle-list',
    Component: VehiclesListPage,
    isNavigation: true,
    name: t('mobility.myVehicles'),
  },
  {
    path: '/mobility-management/logbook',
    Component: LogbookPage,
    isNavigation: true,
    name: t('common.mobilityLogbook'),
  },
  {
    path: '/mobility-management/logbook/details/:id',
    Component: LogbookPageDetails,
    isNavigation: true,
    name: t('common.mobilityLogbookDetails'),
  },
  {
    path: '/reporting-area',
    Component: ReportingAreaMenuPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.reportingArea'),
  },
  {
    path: '/reporting-area/cost-recovery-report',
    Component: CostRecoveryReportPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.costRecoveryReport'),
  },
  {
    path: '/reporting-area/country-reporting',
    Component: CountryReportPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('crumbs.countryReport'),
  },
  {
    path: '/manuals',
    Component: ResourcesPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.manuals'),
  },
  {
    path: '/trainings',
    Component: ResourcesPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.trainings'),
  },
  {
    path: '/documents',
    Component: ResourcesPage,
    backgroundImage,
    isBackgroundImage: true,
    isNavigation: true,
    name: t('common.documents'),
  },
] as ICrumb[];
